(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.shell:mxAction
	 * @module mx.shell
	 * @restrict 'EA'
	 * @scope {}
	 * @requires {@ref mx.shell.ActionManagerService mx.shell.ActionManagerService}
	 * @description A button linked to an action
	 * @param {mx.shell.Action} action= - Related {@ref mx.shell.Action Action}
	 * @param {bool} is-background@ - Defines whether a component has background. <br /><i>Default: true</i>
	 * @param {bool} use-icon@ - Is it necessary to display icon (icon should be stored in action.icon). <br /><i>Default: true</i>
	 * @param {bool} use-title@ - Is it necessary to display action title (title should be stored in action.title). <br /><i>Default: false</i>
	 * @param {string} html-class@ - A html class for button if needed (optional)
	 * @usage <mx-action action='action' is-background='false' use-icon='true' use-title='false'></mx-action>
	 */
	angular.module('mx.shell').directive('mxAction', function mxActionDirective() {
		MxActionCtrl.$inject = ['mx.shell.ActionExecutorService', '$scope'];

		function MxActionCtrl(actionExecutorService, $scope) {
			var vm = this;
			var action;

			vm.$onInit = function () {
				init();
			};

			Object.defineProperty(vm, 'action', {
				get: function () {
					return action;
				},
				set: function (newAction) {
					action = newAction;
					init();
				},
			});

			$scope.$watch('vm.action.htmlClass', function (newHtmlClass) {
				vm._htmlClasses = [
					vm._useTitle ? '' : vm._isBackground ? 'md-fab' : 'md-icon-button',
					'mx-action-' + (vm.action ? vm.action.name : '').replace(/\./g, '--'),
				].concat(vm.htmlClass ? vm.htmlClass.split(' ') : []);
				vm._htmlClasses.push(newHtmlClass);
			});

			vm.execute = execute;

			return vm;

			function init() {
				Object.defineProperty(vm.action, 'count', {
					get: function () {
						return vm._count;
					},
					set: function (value) {
						vm._count = value;
					},
					configurable: true,
				});

				vm._isBackground = typeof vm.isBackground === 'undefined' || vm.isBackground.toLowerCase() !== 'false' || (vm.action && vm.action.isBackground === true);
				vm._useIcon = typeof vm.useIcon === 'undefined' || vm.useIcon.toLowerCase() !== 'false' || (vm.action && vm.action.useIcon === true);
				vm._useTitle = (typeof vm.useTitle !== 'undefined' && vm.useTitle.toLowerCase() === 'true') || (vm.action && vm.action.useTitle === true);
				vm.hideForMobile = vm.action ? vm.action.hideForMobile : false;
				vm._count = 0;

				vm._htmlClasses = [
					vm._useTitle ? '' : vm._isBackground ? 'md-fab' : 'md-icon-button',
					'mx-action-' + (vm.action ? vm.action.name : '').replace(/\./g, '--'),
				].concat(vm.htmlClass ? vm.htmlClass.split(' ') : []);
			}

			function execute() {
				if (!vm.action) {
					throw new Error('Action directive: an action was not provided.');
				}
				var selectedObjects = vm.context ? [vm.context] : undefined;

				actionExecutorService.execute(vm.action, selectedObjects).catch(mx.logCatch);
			}
		}

		return {
			scope: {},
			bindToController: {
				action: '<',
				context: '<',
				isBackground: '@',
				useIcon: '@',
				useTitle: '@',
				htmlClass: '@',
			},
			controller: MxActionCtrl,
			controllerAs: 'vm',
			templateUrl: 'components/mx-action/mx-action.html',
		};
	});
})();
